export default __webpack_public_path__ + "static/media/mail.13c7aa7c.svg";